module.exports = __webpack_public_path__ + "img/Datenglossar.825f4096.png";